import type { GraphNodeRow } from '../../knowledgecenter/framework';

type Props = { nodes?: GraphNodeRow[] };

export function KnowledgeGraphPanel({ nodes = [] }: Props) {
  return (
    <div className="space-y-2">
      {nodes.map((n) => (
        <div key={n.name} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{n.name}</p>
            <p className="mt-0.5 text-xs text-slate-500">{n.entity}</p>
          </div>
          <p className="shrink-0 text-sm font-semibold text-brand-600">{n.links} links</p>
        </div>
      ))}
    </div>
  );
}
